import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);
  const [orderNote, setOrderNote] = useState("");

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const lines = cartItems
    .map((item) => ({ item, product: getProductById(item.id) }))
    .filter(({ product }) => Boolean(product));

  const subtotal = lines.reduce(
    (total, { item, product }) =>
      total + Number(String(product.price).replace(/,/g, "")) * item.quantity,
    0
  );

  const formatPrice = (price) =>
    `$${Number(price).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (lines.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (lines.length === 0) {
    return (
      <main className="cart-page" id="MainContent">
        <section className="cart-page__empty">
          <h1>Cart</h1>
          <p>Your cart is currently empty.</p>
          <Link to="/shop" onClick={toTop} className="cart-page__button">
            Continue Shopping
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="cart-page" id="MainContent">
      <div className="cart-page__container">
        <div className="cart-page__layout">
          <section className="cart-page__content" aria-labelledby="cart-title">
            <header className="cart-page__header">
              <h1 id="cart-title">Cart</h1>
              <Link to="/shop" onClick={toTop} className="cart-page__continue">
                Continue Shopping
              </Link>
            </header>

            <div className="cart-page__items">
              {lines.map(({ item, product }) => {
                const lineTotal = Number(product.price) * item.quantity;

                return (
                  <article
                    className="cart-line"
                    key={`${item.id}-${item.size}-${item.color}`}
                  >
                    <Link
                      className="cart-line__image"
                      to={`/shopDetails/${product.id}`}
                      onClick={toTop}
                    >
                      <img src={product.image} alt={product.name} />
                    </Link>

                    <div className="cart-line__content">
                      <div className="cart-line__details">
                        <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                          {product.name}
                        </Link>
                        <p>{item.color}</p>
                        <p>{item.size}</p>
                        <button
                          type="button"
                          className="cart-line__remove"
                          onClick={() =>
                            removeFromCart(item.id, item.size, item.color)
                          }
                        >
                          Remove
                        </button>
                      </div>

                      <p className="cart-line__price">
                        {formatPrice(lineTotal)}
                      </p>

                      <div
                        className="cart-line__quantity"
                        aria-label="Quantity selector"
                      >
                        <button
                          type="button"
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity - 1
                            )
                          }
                          disabled={item.quantity === 1}
                          aria-label={`Decrease quantity of ${product.name}`}
                        >
                          −
                        </button>
                        <span aria-live="polite">{item.quantity}</span>
                        <button
                          type="button"
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity + 1
                            )
                          }
                          aria-label={`Increase quantity of ${product.name}`}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>

          <aside className="cart-page__aside" aria-label="Order summary">
            <div className="cart-page__delivery-message">
              <svg viewBox="0 0 36 36" aria-hidden="true">
                <path
                  className="cart-page__delivery-track"
                  d="M18 2.0845a15.9155 15.9155 0 0 1 0 31.831 15.9155 15.9155 0 0 1 0-31.831"
                />
                <path
                  className="cart-page__delivery-progress"
                  strokeDasharray="100, 100"
                  d="M18 2.0845a15.9155 15.9155 0 0 1 0 31.831 15.9155 15.9155 0 0 1 0-31.831"
                />
              </svg>
              <span>
                标准配送费为每单 $9.99。
              </span>
            </div>

            <div className="cart-page__subtotal">
              <span>Subtotal</span>
              <strong>{formatPrice(subtotal)}</strong>
            </div>

            <details className="cart-page__widget">
              <summary>Add order and gift notes</summary>
              <div className="cart-page__widget-content">
                <label htmlFor="cart-order-note">
                  Leave a note about your order or gift
                </label>
                <textarea
                  id="cart-order-note"
                  value={orderNote}
                  onChange={(event) => setOrderNote(event.target.value)}
                />
              </div>
            </details>

            <details className="cart-page__widget">
              <summary>Estimate shipping</summary>
              <div className="cart-page__widget-content">
                <p>
                  Available delivery methods are confirmed after you enter your
                  address at checkout.
                </p>
                <Link to="/shipping" onClick={toTop}>
                  View shipping policy
                </Link>
              </div>
            </details>

            <div className="cart-page__checkout-block">
              <button type="button" onClick={handleCheckout}>
                Check Out
              </button>
              <em>
                结算时将加收 $9.99 配送费。
              </em>
            </div>
          </aside>
        </div>
      </div>
    </main>
  );
};

export default CartPage;
